import { render, staticRenderFns } from "./Restaurant.vue?vue&type=template&id=0f995f62&scoped=true&"
import script from "./Restaurant.vue?vue&type=script&lang=js&"
export * from "./Restaurant.vue?vue&type=script&lang=js&"
import style0 from "./Restaurant.vue?vue&type=style&index=0&id=0f995f62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f995f62",
  null
  
)

export default component.exports